var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.499,
    cy: 10.5002,
    r: 10.5,
    fill: "#00BDA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 10.5002C20.999 16.2992 16.298 21.0002 10.499 21.0002C4.70003 21.0002 -0.000976562 16.2992 -0.000976562 10.5002C-0.000976562 4.70125 4.70003 0.000244141 10.499 0.000244141C16.298 0.000244141 20.999 4.70125 20.999 10.5002ZM3.23932 10.5002C3.23932 14.5097 6.4896 17.7599 10.499 17.7599C14.5084 17.7599 17.7587 14.5097 17.7587 10.5002C17.7587 6.49082 14.5084 3.24054 10.499 3.24054C6.4896 3.24054 3.23932 6.49082 3.23932 10.5002Z",
    fill: "#FCFDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCircle);
export default __webpack_public_path__ + "static/media/status-circle.e90af4543ac8381c29058dc0ad78fa4a.svg";
export { ForwardRef as ReactComponent };